/**
 * @param {string|number} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function accountNo ({ value, validationValue }) {
  if (!validationValue) return true
  return !!value
}

module.exports = { accountNo }
